const btns = document.querySelectorAll('.btn-partager');
const popoverEl = document.getElementById('share-popover');
const inputaddpassword = document.getElementById('password-input');
const confirmBtn = document.getElementById('confirm-share');
let postId, slug;

btns?.forEach(btn => {
    btn.addEventListener('click', (e) => {
        postId = btn.dataset.postId;
        slug = btn.dataset.slug;
        inputaddpassword.value = Math.random().toString(36).slice(-8); // password par défaut
    });
});

confirmBtn?.addEventListener('click', async () => {
    const password = inputaddpassword.value;

    const formData = new FormData();
    formData.append('action', 'add_password');
    formData.append('post_id', postId);
    formData.append('password', password);
    formData.append('add_password_nonce', WPData.nonceAddPassword);

    const res = await fetch(WPData.ajaxUrl, { method: 'POST', body: formData });
    const data = await res.json();

    if (data.success) {
        const passwordFieldWrapper = document.querySelector('.password-field__wrapper');
        const resultWrapper = document.querySelector('.result__wrapper');
        const passwordWrapper = resultWrapper.querySelector('.password-result');
        const copylabel = passwordWrapper.querySelector('p');
        const copyButton = passwordWrapper.querySelector('button');

        copylabel.innerText = password;
        copyButton.setAttribute('data-clipboard-text', password);

        resultWrapper.classList.remove('hidden');
        passwordFieldWrapper.classList.add('hidden');


        // const link = `${location.origin}/partage/?slug=${slug}`;
        // navigator.clipboard.writeText(link);
        // alert('Lien copié !');

    } else {
        alert('Erreur : ' + data.message);
    }

    // popoverEl.hidePopover(); // fermer le popover
});